import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=efbe20b0&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=js&"
export * from "./ActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=efbe20b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbe20b0",
  null
  
)

export default component.exports